import React from "react";
import { Annotation } from "./annotationParser";

type Props = {
    annotations: Annotation[];
};

const AnnotationsOverlay: React.FC<Props> = ({ annotations }) => (
    <div div
        style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            pointerEvents: "none",
        }}
    >
        {
            annotations.map((a, i) => {
                if (a.type === "triangle") {
                    let scale = a.size || 1;
                    const size = 2.6;

                    return (
                        <div
                            style={{
                                position: "absolute",
                                top: (a.y/* - (size/2)*/) + '%',
                                left: (a.x/* - (size/2)*/) + '%',
                                width: size + "%",
                                aspectRatio: "1 / 1",
                                background: a.color || "#d3343f",
                                clipPath: "polygon(49% 0%, 0% 80%, 98% 80%)",
                                transform: `scale(${scale}) rotate(${a.rotation || 0}deg)`,
                            }}
                        ></div>
                    );

                }
                if (a.type === "dot") {
                    let scale = a.size || 1;
                    const size = 2.2;

                    return (
                        <div
                            style={{
                                position: "absolute",
                                top: (a.y/* - (size/2)*/) + '%',
                                left: (a.x/* - (size/2)*/) + '%',
                                width: size + "%",
                                aspectRatio: "1 / 1",
                                background: a.color || "#d3343f",
                                borderRadius: "50%",
                                transform: `scale(${scale}) rotate(${a.rotation || 0}deg)`,
                            }}
                        ></div>
                    );

                }
                if (a.type === "square") {
                    let scale = a.size || 1;
                    const size = 2.1;

                    return (
                        <div
                            style={{
                                position: "absolute",
                                top: (a.y/* - (size/2)*/) + '%',
                                left: (a.x/* - (size/2)*/) + '%',
                                width: size + "%",
                                aspectRatio: "1 / 1",
                                background: a.color,
                                transform: `scale(${scale}) rotate(${a.rotation || 0}deg)`,
                            }}
                        ></div>
                    );

                }
                if (a.type === "text") {
                    let scale = a.size || 1;
                    const size = 1.6;
                    let text = a.label;

                    return (
                        <b
                            style={{
                                position: "absolute",
                                top: "calc(" + a.y + "% - 0.15ch)",
                                left: "calc(" + a.x + "% )",
                                fontSize: size + "cqw",
                                width: "max-content",
                                background: a.color || "#d3343f",
                                color: a.textColor || "#ffffff",
                                fontWeight: 700,
                                boxShadow: "0px 0px 7px 2px rgba(0,0,0,0.07)",
                                display: "inline-block",
                                padding: "0.3ch 0.3ch 0.2ch 0.3ch",
                                fontFamily: "Roboto, sans-serif",
                                lineHeight: '1',
                                transform: `scale(${scale}) rotate(${a.rotation || 0}deg)`,
                            }}
                            title={text}
                        >
                            {text}
                        </b>

                    );

                }
                if (a.type === "trtext") {
                    let scale = a.size || 1;
                    const size = 1.6;
                    let text = a.label;

                    return (
                        <b
                            style={{
                                position: "absolute",
                                top: "calc(" + a.y + "% - 0.15ch)",
                                left: "calc(" + a.x + "% )",
                                fontSize: size + "cqw",
                                width: "max-content",
                                background: "transparent",
                                color: a.textColor || "#ffffff",
                                fontWeight: 700,
                                display: "inline-block",
                                padding: "0.3ch 0.3ch 0.2ch 0.3ch",
                                fontFamily: "Roboto, sans-serif",
                                lineHeight: '1',
                                transform: `scale(${scale}) rotate(${a.rotation || 0}deg)`,
                            }}
                            title={text}
                        >
                            {text}
                        </b>

                    );

                }
                return null;
            })
        }
    </div>
);

export default AnnotationsOverlay;